import styled from 'styled-components';
import { CloseOutline } from '@styled-icons/evaicons-outline/CloseOutline';

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 8%;
  
  form {
    width: 20%;
  }

  @media only screen and (max-width: 767px) {
    height: 68%;
    form {
      width: 90%;
    }
  }

`;

export const Form = styled.form`

  div {
    display: flex;
    justify-content: space-even;
    align-items: center;
    label {
      width: 100%;
    }
  }

  @media only screen and (max-width: 767px) {
    width: 90%;

    div, input {
      margin: 20px auto;
      width: 100%;
    }

    label {
      display: none;
    }
  }
`;

export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.modal ? 'space-between' : 'flex-end'};
  margin-right: 5px;

  margin-top: ${props => props.modal ? '40px' : 'initial'};

  @media only screen and (max-width: 768px) {
    flex-direction: ${props => props.modal ? 'column' : 'row'};
  }
`;


export const ModalBody = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70vw;
  height: 80vh;
  background: #FFF;
`;

export const ModalButton = styled.button`
  background: none;
  border: none;
  position: absolute;
  right: 1%;
  top: 1%;
  cursor: pointer;

  :hover {
    svg path {
      fill: #aE1717;
    }
  }
`;

export const CloseIcon = styled(CloseOutline)`
  width: 50px;
  height: 50px;

  color: #CE1717;
`;

export const ModalInfo = styled.div`
  // width: 50vw;
`;  

